const Header = () => {
    return <h1>How fast do you type?</h1>;
};

export default Header;
